import styles from './AppBadges.module.scss';

export const AppBadges = () => {
  return (
    <div className={styles.container}>
      <a
        href="https://apps.apple.com/us/app/on3-elite/id6448636752"
        rel="noreferrer"
        target="_blank"
      >
        <img
          alt="Apple Store Logo"
          src="https://on3static.com/static/on3/apple-store.png"
        />
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=com.on3.athletenetwork"
        rel="noreferrer"
        target="_blank"
      >
        <img
          alt="Google Play Logo"
          src="https://on3static.com/static/on3/google-play.png"
        />
      </a>
    </div>
  );
};
